export const REMOVED_CUSTOMERS_LIMIT = 300;
